import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { BcDialogService } from '@bancolombia/design-system-web/bc-services';
import { EstadoServicesService } from 'src/app/services/estado-services/estado-service';
import { BcAlertComponent } from '@bancolombia/design-system-web/bc-alert';
import { formatearFechaCorta } from 'src/app/components/utils/formato-fecha.componente';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MenuOptions } from 'src/app/components/float-menu-aba/float-menu-aba.component';
import { BcModalComponent } from '@bancolombia/design-system-web/bc-modal';

@Component({
  selector: 'app-detalles-contrato-user',
  templateUrl: './detalles-contrato-user.component.html',
  styleUrls: ['./detalles-contrato-user.component.css']
})
export class DetallesContratoUserComponent {

  @Input('contractDetail') _contract!: any;
  @Input('contractChild') contractsChilds!: any;
  @Input('contractMaster') contractMaster!: any;
  @Input('userData') userData!: any;

  /**
* Objeto que representa el contrat.
* @typedef {Object} Contrato
* @property {string} idContrato - Identificador del contrato.
* @property {Object} administrador - Información del administrador del contrato.
* @property {string} administrador.usuarioRed - Usuario de red del administrador.
* @property {string} administrador.nombre - Nombre del administrador.
* @property {string} administrador.correo - Correo electrónico del administrador.
* @property {Object} negociador - Información del negociador del contrato.
* @property {string} negociador.usuarioRed - Usuario de red del negociador.
* @property {string} negociador.nombre - Nombre del negociador.
* @property {string} negociador.correo - Correo electrónico del negociador.
* @property {Object} proveedor - Información del proveedor del contrato.
* @property {string} proveedor.id - Identificador del proveedor.
* @property {string} proveedor.nombre - Nombre del proveedor.
* @property {string} proveedor.nit - NIT del proveedor.
* @property {string} proveedor.nombreComercial - Nombre comercial del proveedor.
* @property {string} proveedor.correoComercial - Correo electrónico del contacto comercial del proveedor.
* @property {string} proveedor.contactoComercial - Número de contacto del contacto comercial del proveedor.
* @property {Object} estado - Información del estado del contrato.
* @property {number} estado.idEstado - Identificador del estado.
* @property {string} estado.estado - Descripción del estado.
* @property {Array<Object>} contratosHijos - Lista de contratos hijos del contrato.
* @property {string} contratosHijos.idContrato - Identificador del contrato hijo.
* @property {Object} contratosHijos.proveedor - Información del proveedor del contrato hijo.
* @property {string} contratosHijos.proveedor.id - Identificador del proveedor.
* @property {string} contratosHijos.proveedor.nombre - Nombre del proveedor.
* @property {string} contratosHijos.proveedor.nit - NIT del proveedor.
* @property {Object} contratosHijos.estado - Información del estado del contrato hijo.
* @property {number} contratosHijos.estado.idEstado - Identificador del estado.
* @property {string} contratosHijos.estado.estado - Descripción del estado.
* @property {string} contratosHijos.nombre - Nombre del contrato hijo.
* @property {Object} contratoPadre - Información del contrato padre.
* @property {string} contratoPadre.idContrato - Identificador del contrato padre.
* @property {Object} contratoPadre.proveedor - Información del proveedor del contrato padre.
* @property {string} contratoPadre.proveedor.id - Identificador del proveedor.
* @property {string} contratoPadre.proveedor.nombre - Nombre del proveedor.
* @property {string} contratoPadre.proveedor.nit - NIT del proveedor.
* @property {Object} contratoPadre.estado - Información del estado del contrato padre.
* @property {number} contratoPadre.estado.idEstado - Identificador del estado.
* @property {string} contratoPadre.estado.estado - Descripción del estado.
*/

  private static URL_POWERAPPS_ESCALAMIENTO = "https://apps.powerapps.com/play/e/030e1206-2356-eb46-b90a-be6ab6655b0d/a/47c50454-b1bb-42aa-a177-2a8deb5c3e84?tenantId=b5e244bd-c492-495b-8b10-61bfd453e423&hint=90f36883-f672-4a21-b591-770114f970e8&sourcetime=1722975707835&source=portal?screenname=Escalamiento&id_contrato="
  private static URL_POWERAPPS_DECISION_IMPORTANTE = "https://apps.powerapps.com/play/e/030e1206-2356-eb46-b90a-be6ab6655b0d/a/47c50454-b1bb-42aa-a177-2a8deb5c3e84?tenantId=b5e244bd-c492-495b-8b10-61bfd453e423&hint=90f36883-f672-4a21-b591-770114f970e8&sourcetime=1722975707835&source=portal?screenname=DecisionesImportantes&id_contrato="
  private static URL_SHAREPOINT_TERMINACION_CONTRATO = "https://bancolombia.sharepoint.com/sites/co-dca/SitePages/dca_noticias_cierre-de-contrato-proveedores.aspx?from=%3DLightGBM&xsdata=MDV8MDJ8anVsaWhlcnJAYmFuY29sb21iaWEuY29tLmNvfDJjOTI3MDhmMzhmODRkMzdjMDBmMDhkY2MzOGM2MTRjfGI1ZTI0NGJkYzQ5MjQ5NWI4YjEwNjFiZmQ0NTNlNDIzfDB8MHw2Mzg2MDAyNTUyMDAyODE1MzV8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpXSWpvaU1DNHdMakF3TURBaUxDSlFJam9pVjJsdU16SWlMQ0pCVGlJNklrMWhhV3dpTENKWFZDSTZNbjA9fDB8fHw%3D&sdata=OG9EY2hPMkkzV1RNNHV4b2Q4QXpNSDN2bTFwV0VSN2p0SVFTT1B5UjlWST0%3D&CT=1724679292891&OR=OWA-NT-Mail&CID=bc119d34-8739-5ec0-11b5-0e9cd05095d0&clickParams=eyJYLUFwcE5hbWUiOiJNaWNyb3NvZnQgT3V0bG9vayBXZWIgQXBwIiwiWC1BcHBWZXJzaW9uIjoiMjAyNDA4MTYwMDMuMTEiLCJPUyI6IldpbmRvd3MgMTEifQ%3D%3D";

  @ViewChild('menuOptionsModal', { static: true })
  menuOptionsModal: BcModalComponent | any;
  menuOptions: MenuOptions[] = []

  goToLink(eventType: number) {
    if (eventType === 1) window.open(DetallesContratoUserComponent.URL_SHAREPOINT_TERMINACION_CONTRATO, '_blank');
  }

  ngOnChanges(changes: SimpleChanges) {
    const contractExists = changes['_contract'] && this._contract
    if (contractExists) this.createMenuOptions(this._contract?.idContract);
  }


  createMenuOptions(idContract: string) {
    this.menuOptions = [
      { id: '1', label: 'Radicar escalamiento', icon: 'plus', link: DetallesContratoUserComponent.URL_POWERAPPS_ESCALAMIENTO + idContract },
      { id: '2', label: 'Documentar decisión importante', icon: 'document', link: DetallesContratoUserComponent.URL_POWERAPPS_DECISION_IMPORTANTE + idContract },
      { id: '3', label: 'Terminar un contrato', icon: 'block', onClick: () => { this.menuOptionsModal.openModal() } }
    ]
  }

  dateformat(date: any) {
    return date != null ? formatearFechaCorta(new Date(date)) : ""
  }

  //Copiar Administrador
  @ViewChild('correoAdministrador', { static: false }) correoElement?: ElementRef;


  copiarCorreoAdministrador() {
    const correo = this.correoElement?.nativeElement.textContent;
    navigator.clipboard.writeText(correo);
  }


  @ViewChild('correoDelegado', { static: false }) correoElementDelegado?: ElementRef;


  /**
 * Copia el correo electrónico del delegado al portapapeles.
 * 
 * @returns {void}
 */
  copiarCorreoDelegado() {
    const correo = this.correoElementDelegado?.nativeElement.textContent;
    navigator.clipboard.writeText(correo);
  }


  @ViewChild('correoNegociador', { static: false }) correoElementNegociador?: ElementRef;


  copiarCorreoNegociador() {
    const correo = this.correoElementNegociador?.nativeElement.textContent;
    navigator.clipboard.writeText(correo);
  }


  @ViewChild('correoProveedorComercial', { static: false }) correoElementProveedorComercial?: ElementRef;


  /**
 * Copia el correo electrónico del proveedor al portapapeles.
 * 
 * @returns {void}
 */
  copiarCorreoProveedorComercial() {
    const correo = this.correoElementProveedorComercial?.nativeElement.textContent;
    navigator.clipboard.writeText(correo);

  }

  estadoSeleccionado: string | null = null;

  constructor(
    private estadoService: EstadoServicesService,
    private dialogService: BcDialogService,
    private router: Router,
    private http: HttpClient
  ) {
    this.estadoSeleccionado = this.estadoService.getEstadoSeleccionado();
    console.log('Estado seleccionado recibido:', this.estadoSeleccionado);
  }

  compareDates(a: any, b: any): number {
    const dateA = new Date(a.fechaInicio);
    const dateB = new Date(b.fechaInicio);

    return dateA.getTime() - dateB.getTime();
  }




  // ...

  getFormattedDate(date: string | null): string {
    if (!date) {
      return 'Fecha no disponible';
    }

    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) {
      return 'Fecha inválida';
    }

    return parsedDate.toLocaleDateString();
  }

  alertAba(type: String, menssage: String, tittle: string): void {
    const dialogRef = this.dialogService.open(BcAlertComponent, {
      id: tittle,
      type: type,
      text: menssage,
      timeout: 7000,
    });

    dialogRef.onResult().subscribe(
      (closed) => { },
      (dismissed) => { },
      () => { }
    );
  }

  mostrarReportarCambioEstado: boolean = false;

  toggleReportarCambioEstado() {
    this.mostrarReportarCambioEstado = !this.mostrarReportarCambioEstado;
  }


  //Ruta
  goBack() {
    this.router.navigate(['./contratos']);
  }


  ordenarMayorMenor(): void {
    this.contractsChilds.sort((a: any, b: any) => {
      const dateA = a.finalDate ? new Date(a.finalDate) : null;
      const dateB = b.finalDate ? new Date(b.finalDate) : null;

      if (dateA && dateB) {
        return dateB.getTime() - dateA.getTime();
      } else if (dateA) {
        return -1;
      } else if (dateB) {
        return 1;
      } else {
        return 0;
      }
    });

  }

  ordenarMenorMayor(): void {
    this.contractsChilds.sort((a: any, b: any) => {
      const dateA = a.finalDate ? new Date(a.finalDate) : null;
      const dateB = b.finalDate ? new Date(b.finalDate) : null;

      if (dateA && dateB) {
        return dateA.getTime() - dateB.getTime();
      } else if (dateA) {
        return 1;
      } else if (dateB) {
        return -1;
      } else {
        return 0;
      }
    });
  }


  ascendente: boolean = true;

  ordenarPorFecha(orden: string): void {
    this.contractsChilds.sort((a: any, b: any) => {
      const dateA = a[orden] ? new Date(a[orden]) : null;
      const dateB = b[orden] ? new Date(b[orden]) : null;

      if (dateA && dateB) {
        return this.ascendente ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
      } else if (dateA) {
        return -1;
      } else if (dateB) {
        return 1;
      } else {
        return 0;
      }
    });
    this.ascendente = !this.ascendente; // Cambiar el estado de la variable
  }

  /*descargarPDF() {
    const url = 'https://neoris0-my.sharepoint.com/personal/juan_sserna_neoris_com/Documents/Document%20(1)%201.pdf';
    this.http.get(url, { responseType: 'blob' }).subscribe(response => {
      const blob = new Blob([response], { type: 'application/pdf' });
      const urlArchivo = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = urlArchivo;
      a.download = 'Algebra-de-A-Baldor.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(urlArchivo);
      document.body.removeChild(a);
    });
  }
  */
  construirURL(): string {
    const baseUrl = 'https://apps.powerapps.com/play/e/030e1206-2356-eb46-b90a-be6ab6655b0d/a/47c50454-b1bb-42aa-a177-2a8deb5c3e84?tenantId=b5e244bd-c492-495b-8b10-61bfd453e423&hint=90f36883-f672-4a21-b591-770114f970e8&sourcetime=1716905748448&source=portal';
    const tenantId = 'b5e244bd-c492-495b-8b10-61bfd453e423';
    const hint = 'cfce1c92-2a51-4251-a1cf-6904ce8b1696';
    const sourcetime = '128736766';
    const source = 'portal';
    const screenname = 'Cierre_contratos';
    return `${baseUrl}?id_contrato=${this._contract.idContract}`;
  }

  abrirEnNuevaPestana() {
    const url = this.construirURL();
    console.log(url)
    window.open(url, '_blank');
  }
}
